import React, { useEffect, useState, ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';

import './scss/time-tab.scss';
import Color from '@tool/color';
import ShapeIcon from '@static/icon/shape01.png';

interface IProps {
  active: string | number
  list: any[]
  onChange: (val: any) => void
}
interface IState { }

const TimeTab = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { list, onChange, active } = props;

  useEffect(() => {
    return () => { };
  }, []);

  return (
    <section className="time-tab-warp">
      <section className="top">
        {
          list?.map((res: any, r: any) => {
            return <section key={`${r.toString()}`} className="top-item">
              <b
                onClick={() => { onChange(res); }}
                className={active.toString() === res.toString() ? 'active-tab' : ''}>
              </b>
            </section>;
          })
        }
      </section>
      <section className="bot">
        {
          list?.map((res: any, r: any) => {
            return <b key={`${r.toString()}`}
              onClick={() => { onChange(res); }}
              className={active.toString() === res.toString() ? 'active-tab' : ''}>
              {res}
            </b>;
          })
        }
      </section>
    </section>
  );
};

export default observer(TimeTab);
